<div class="mt-1">
  <div class="grid">
    <div class="col-12 p-fluid formgrid">
      <form [formGroup]="form">

        <div class="col">
          <label>{{ 'WarehouseCalendar.EditDialog.DescrLabel' | translate }}</label>
          <input formControlName="descr" pInputText [(ngModel)]="descr"
            [class]="isShowOverLengthMsg(form.controls.descr, submitted, 30) ? ['ng-invalid', 'ng-dirty'] : []"/>
          <div *ngIf="isShowOverLengthMsg(form.controls.descr, submitted, 30)" >
            <small *ngIf="isShowOverLengthMsg(form.controls.descr, submitted, 30)" class="p-invalid">{{ 'WarehouseCalendar.EditDialog.OverLengthMsg' | translate }}</small>
          </div>
        </div>

        <div class="col">
          <label>{{ 'WarehouseCalendar.EditDialog.MemoLabel' | translate }}</label>
          <input pInputText [(ngModel)]="memo" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="field col">
          <label>{{ 'WarehouseCalendar.EditDialog.VacationLabel' | translate }}</label>
          <br/>
          <p-inputSwitch [(ngModel)]="isWorkDay" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
        </div>

        <div *ngIf="calendarEvents.length > 0" class="col grid">
          <div class="col">
            <label>{{ 'WarehouseCalendar.EditDialog.CreateUserLabel' | translate }}</label>
            <label>{{ createUser }}</label>
          </div>
          <div class="col text-right">
            <label>{{ 'WarehouseCalendar.EditDialog.LastUpdateUserLabel' | translate }}</label>
            <label>{{ updateUser }}</label>
          </div>
      </div>

    </form>
  </div>
  <div class="ml-2 mt-2">
    <div class="col text-center">
      <button pRipple pButton label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick($event)"></button>
      <button pRipple pButton class="p-button-secondary ml-2" label="{{ 'Common.Button.Delete' | translate }}" (click)="deleteBtnConfirm($event)"></button>
    </div>
  </div>

</div>
